<template>
  <form element-loading-background="rgba(0, 0, 0, 0.2)" v-loading="loading" @submit.prevent="">
    <div>
      <div class="login_panel">
        <div class="login_title">
          <span>系统登录</span>
        </div>

        <div class="mgt-20 form_item_container">
          <el-input
            placeholder="输入用户名"
            v-model="formObject.username"
            class="username"
            ref="username"
            clearable
          >
            <i slot="prefix" class="el-input__icon el-icon-user-solid form_item_icon"></i>
          </el-input>
        </div>

        <div class="mgt-20 form_item_container">
          <el-input
            placeholder="输入密码"
            type="password"
            v-model="formObject.password"
            class="password"
            clearable
          >
            <i slot="prefix" class="el-input__icon el-icon-lock form_item_icon"></i>
          </el-input>
        </div>

        <!-- TODO暂不需要发版UAT环境 -->
        <div class="mgt-20 form_item_container code_wrap">
          <el-input
            placeholder="输入验证码"
            v-model="formObject.image_vertiy_code"
            :maxlength="4"
            class="code">
            <i slot="prefix" class="el-input__icon el-icon-lock form_item_icon"></i>
          </el-input>
          <img ref="codeImg" class="verify-code pointer" @click="reloadCodeImage"/>
        </div>

        <!-- 该功能保留 -->
        <!-- <div class="mgt-30">
              <el-checkbox v-model="remenber" label="记住用户名和密码" border></el-checkbox>
        </div>-->
        <!-- 该功能保留 -->


        <div class="mgt-20 form_item_container">
          <button class="el-button login_btn el-button--primary" type="submit" @click="submit">
            登 录
          </button>
          <!--          <div class="txt-right pdt-10">-->
          <!--            <el-link class="fs-12 bold" type="info" href="https://bip.bgyfw.com" target="_blank">有bip账号的人找回密码</el-link>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </form>
</template>

<script>


import {mapActions} from "vuex";
import {utils} from "../../components";
import {Notification} from 'element-ui'

export default {
  data() {
    return {
      loading: false
      , fetchCodeUrl: '/oauth2/oauth/image_code'
      , formObject: {
        username: "",
        image_vertiy_code: "",
        password: ""
      }
    };
  },
  methods: {
    ...mapActions(["login"])
    , submit() {

      this.loading = true;
      this.login(this.formObject).then(result => {
        if (result.hasOwnProperty("access_token")) {
          this.gotoHomePage(result)
        } else {
          this.gotoVerifyPage(result)
        }
      }).catch(() => {
        this.formObject.image_vertiy_code = ""
        // this.formObject.password = ""
        this.reloadCodeImage()
      }).finally(() => {
        this.loading = false;
      });


    }
    , reloadCodeImage() {
      if (utils.isNotEmpty(this.fetchCodeUrl))
        this.$refs.codeImg.setAttribute('src', this.fetchCodeUrl)
    }
    , gotoHomePage(result) {
      console.log('gotoHomePage')
      let token = result["access_token"];
      this.$cookie.set("token", token);
      location.href = "./";
    }
    , gotoVerifyPage({phone, tmp_access_token}) {
      if (utils.isEmpty(phone)) {
        Notification.error("登陆异常!")
        throw new Error('未获取到用户手机号码!')
      }
      this.$router.push({name: 'Verify', params: {phone, tmpAccessToken: tmp_access_token}})
    }

  },
  mounted() {
    this.$refs.username.focus();
    this.reloadCodeImage()
  }
};
</script>


<style lang="scss" scoped>
.code_wrap {
  position: relative;
}

.verify-code {
  width: 90px;
  height: 24px;

  position: absolute;
  right: 10px;
  top: 13px;
  z-index: 1;
}
</style>
